const config = {
  path: '',
  defaultTimeout: 20000,
  contentType: 'text/plain',
  postData: null,
  hmacId: null,
  card: null,
  headers: {
    'Cache-Control': 'no-cache',
  },
  parameters: {},
  host: null,
  basePath: null,
};

export default config;
